// extracted by mini-css-extract-plugin
export default {"Panel":"Panel__Panel___ffrPH","panelHeader":"Panel__panelHeader___iyRKZ","panelHeading":"Panel__panelHeading___czwh_"};